export const PUBLIC_WEB_ORIGIN = 'https://route.camp'

export function isTauri(): boolean {
  return typeof window !== 'undefined' && '__TAURI_INTERNALS__' in window
}

export function webOrigin(): string {
  return isTauri() ? PUBLIC_WEB_ORIGIN : window.location.origin
}

export function isAppleMobile(): boolean {
  return /iPad|iPhone|iPod/.test(navigator.userAgent)
}

export function isAndroidMobile(): boolean {
  return /Android/.test(navigator.userAgent)
}

export function isTauriAppleMobile(): boolean {
  return isTauri() && isAppleMobile()
}

export function isTauriAndroidMobile(): boolean {
  return isTauri() && isAndroidMobile()
}

export function isTauriMobile(): boolean {
  return isTauriAppleMobile() || isTauriAndroidMobile()
}
